import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
//Material
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
//Components
import { useSyles } from './styles.style';
import Layout from '../common/Layout';
import { useAppSelector } from '../../redux/hooks';
import { getAllTimeZones } from '../../redux/time_zones/thunks';
import { useDispatch } from 'react-redux';

type PropsForm = {
  submitWarehouse: (_: any) => void;
  initialValues: any;
  actionText?: any;
};
const Form = ({ submitWarehouse, initialValues, actionText }: PropsForm) => {
  const navigate = useNavigate();
  const classes = useSyles();
  const dispatch = useDispatch<any>();
  const { timezones } = useAppSelector(({ timeZones }) => timeZones);
  // función que redirige de forma programada
  const cancelAdd = () => {
    navigate(`/warehouses`, { replace: true });
  };

  const fetchTimezones = useCallback(async () => {
    dispatch(getAllTimeZones());
  }, []);

  const onAction = () => formik?.handleSubmit();

  const validationSchema = yup.object({
    name: yup.string().required('Escribe un nombre'),
    address: yup.string(),
    time_zone_id: yup.number(),
    status_warehouses_id: yup.number(),
  });
  const { name, address, time_zone, time_zone_id, status_warehouses_id } =
    initialValues;
  const formik = useFormik({
    initialValues: {
      name,
      address,
      time_zone_id: time_zone?.id || time_zone_id,
      status_warehouses_id,
    },
    validationSchema: validationSchema,
    onSubmit: (values: any) => submitWarehouse(values),
  });

  useEffect(() => {
    fetchTimezones();
  }, []);
  return (
    <Layout>
      <div className={classes.container}>
        <form className={classes.form} onSubmit={formik.handleSubmit}>
          <TextField
            id='form-name'
            name='name'
            label='Nombre del almacen'
            variant='outlined'
            required
            fullWidth
            value={formik.values?.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={
              formik.touched.name && formik.errors.name
                ? 'Escribe un nombre'
                : false
            }
          />
          <TextField
            id='form-address'
            name='address'
            label='Dirección'
            variant='outlined'
            fullWidth
            value={formik.values?.address}
            onChange={formik.handleChange}
          />
          <FormControl variant='outlined'>
            <InputLabel id='pytz_zone_id-label'>Zona horaria</InputLabel>
            <Select
              labelId='pytz_zone_id-label'
              id='pytz_zone_id'
              value={formik.values?.time_zone_id}
              readOnly={Boolean(initialValues.id)}
              onChange={(option) =>
                formik.setFieldValue('time_zone_id', option.target.value)
              }
              label='Zona horaria'
            >
              <MenuItem value=''>
                <em>None</em>
              </MenuItem>
              {timezones?.map((e) => (
                <MenuItem key={e.pytz_zone} value={e.id}>
                  {e.pytz_zone}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <div className={classes.flex}>
            <Button onClick={cancelAdd}>Cancelar</Button>
            <Button
              className={classes.button}
              size='medium'
              color='secondary'
              variant='contained'
              onClick={onAction}
            >
              {actionText}
            </Button>
          </div>
        </form>
      </div>
    </Layout>
  );
};

export default Form;
